import { KeyLabel } from '../../../../shared/domain/key-label.model';

export enum UserActivityType {
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  MEETING = 'MEETING',
  GENERAL = 'GENERAL',
}

export const UserActivityTypeLabels = {
  CALL: 'Call',
  EMAIL: 'Email',
  MEETING: 'Meeting',
  GENERAL: 'General'
};

export const UserActivityTypeLabelsText = {
  CALL: 'called',
  EMAIL: 'send email to',
  MEETING: 'had a meeting with',
  GENERAL: 'general',
};

export const UserActivityTypeKL = () => {
  return Object.keys(UserActivityTypeLabels).map(key => new KeyLabel(key, UserActivityTypeLabels[key]));
};
// without general
export const UserActivityTypeShortKL = () => {
  return Object.keys(UserActivityTypeLabels).filter(item => item !== UserActivityType.GENERAL)
    .map(key => new KeyLabel(key, UserActivityTypeLabels[key]));
};
